
import React, { useEffect, useState } from 'react';
import {TextField,Autocomplete, Button,Checkbox, FormControlLabel, Typography,Box,Dialog,DialogActions,DialogContent,} from '@mui/material';
import AdminToolbar from '../Toolbar/AdminToolbar';
import './addPost.css';
import axios from 'axios';
import { useNavigate } from "react-router-dom";

const AddPost = () => {

   const [userName, setUsername] = useState('');
   const [isLoggedIn, setIsLoggedIn] = useState(false);
   const [userType, setUserType] = useState('jn');
   const navigate = useNavigate();
   const [eventImage, setEventImage] = useState('');
  
  async function getUsernamefromCookie() {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/isLoggedIn`, { withCredentials: true }); 
      if (response.data.username ) {
        setUsername(response.data.username);
        setIsLoggedIn(true);
        setUserType(response.data.user);
      } else {
        setIsLoggedIn(false);
        navigate('/login'); 
      }
    } catch (error) {
      console.error('Error fetching login status:', error);
      navigate('/login'); 
    }
  }

  useEffect(() => {
    getUsernamefromCookie();
  }, []);

  const [enumOptions, setEnumOptions] = useState({
     postingTypes: [],
    categories: [],
    costs: [],
    modes: [],
  });

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [formData, setFormData] = useState({
    hostOrganisation: '',
    eventName: '',
    postStartDate: '',
    postEndDate: '',
    applicationDeadline: '',
    description: '',
     postingTypes: [],
    categories: [],
    cost: '',
    location: '',
    targetGroup: '',
    country: '',
    mode: '',
    hostURL: '',
    // eventPosting: '',
    onlineSessionLink: '',
    postedBy: '',
    createdBy: userName,
    yearlyImportant: false,
  });

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [open, setOpen] = useState(false);
  const [formError, setFormError] = useState('');

  useEffect(() => {
  const fetchEnumOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/categoryValues`);
      setEnumOptions(response.data);
    } catch (err) {
      console.error('Error fetching enum options:', err);
    }
  };
  fetchEnumOptions();
}, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };
  const handleSelectChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleMultiSelectChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: [...value],
    }));
  };
  const [selectedImageFile, setSelectedImageFile] = useState(null);
  const [selectedPdfFiles, setSelectedPdfFiles] = useState([]);

const handleSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitted(true);

  if (formData.categories.length === 0) {
    alert('Please select at least one category.');
    return;
  }

  try {
    let imageUrl = '';
    let uploadedPdfUrls = [];
    if (selectedImageFile) {
      const formDataimage = new FormData();
      formDataimage.append('image', selectedImageFile);
      formDataimage.append('eventName', formData.eventName);
      const res = await axios.post(`${API_BASE_URL}/upload-image`, formDataimage);
       imageUrl = res.data.imageUrl;
    }
    for (const file of selectedPdfFiles) {
      const pdfFormData = new FormData();
      pdfFormData.append("file", file);
      pdfFormData.append('eventName', formData.eventName);
      try {
        const res = await axios.post(`${API_BASE_URL}/upload-pdf`, pdfFormData);
        if (res.data.pdfUrl) uploadedPdfUrls.push(res.data.pdfUrl);
      } catch (err) {
        console.error("Error uploading file:", file.name, err);
      }
    }
    const payload = {
      ...formData,
      createdBy: userName,
      eventImage: imageUrl,
      postedBy: userName,
      attachments: uploadedPdfUrls,
    };

    const response = await axios.post(`${API_BASE_URL}/api/newEvents`, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (response.status === 201) {
      setOpen(true);
    } else {
      console.error('Error:', response.data);
    }
  } catch (error) {
    console.error('Submit error:', error);
  }
};



  const handleClose = () => {
    setOpen(false);
    setFormError('');
    setFormData({
    hostOrganisation: '',
    eventName: '',
    postStartDate: '',
    postEndDate: '',
    applicationDeadline: '',
    description: '',
    postingTypes: [],
    categories: [],
    cost: '',
    location: '',
    targetGroup: '',
    country: '',
    mode: '',
    hostURL: '',
    // eventPosting: '',
    onlineSessionLink: '',
    postedBy: '',
    createdBy: userName, 
    yearlyImportant: false,
  });

  };
const [attachments, setAttachments] = useState([]);

  return (
    <Box>
      {/* <AdminToolbar /> */}

      <Box component="form" className="form-container" onSubmit={handleSubmit}>
        <Box className="grid-container">
          <Box className="field-container">
            <Typography>Host Organization <span className="required">*</span></Typography>
            <TextField name="hostOrganisation" fullWidth value={formData.hostOrganisation} onChange={handleChange} required />
          </Box>

          <Box className="field-container">
            <Typography>Event Name <span className="required">*</span></Typography>
            <TextField name="eventName" fullWidth value={formData.eventName} onChange={handleChange} required />
          </Box>

          <Box className="field-container">
            <Typography>Post Start Date <span className="required">*</span></Typography>
            <TextField name="postStartDate" type="date" InputLabelProps={{ shrink: true }} fullWidth value={formData.postStartDate} onChange={handleChange} required />
          </Box>

          <Box className="field-container">
            <Typography>Post End Date</Typography>
            <TextField name="postEndDate" type="date" InputLabelProps={{ shrink: true }} fullWidth value={formData.postEndDate} onChange={handleChange} />
          </Box>

          <Box className="field-container">
            <Typography>Application Deadline</Typography>
            <TextField name="applicationDeadline" type="date" InputLabelProps={{ shrink: true }} fullWidth value={formData.applicationDeadline} onChange={handleChange} />
          </Box>

          {/* <Box className="field-container">
            <Typography> Posting Type <span className="required">*</span></Typography>
            <Autocomplete
              multiple
              options={enumOptions.postingTypes}
              getOptionLabel={(option) => option || ''}
              value={formData.postingTypes}
              onChange={(event, newValue) => handleMultiSelectChange('postingTypes', newValue)}
              renderInput={(params) => <TextField {...params} />}
            />
          </Box> */}

          <Box className="field-container">
            <Typography>Tag <span className="required">*</span></Typography>
            <Autocomplete
              multiple
              options={enumOptions.categories}
              getOptionLabel={(option) => option || ''}
              value={formData.categories}
              onChange={(event, newValue) => handleMultiSelectChange('categories', newValue)}
              renderInput={(params) => <TextField {...params} />}
            />
          </Box>
          
          <Box className="field-container">
            <Typography>Cost <span className="required">*</span></Typography>
            <Autocomplete
              options={enumOptions.costs}
              getOptionLabel={(option) => option || ''}
              value={formData.cost}
              onChange={(event, newValue) => handleSelectChange('cost', newValue)}
              renderInput={(params) => <TextField {...params} required />}
            />
          </Box>

          <Box className="field-container">
            <Typography>Mode <span className="required">*</span></Typography>
            <Autocomplete
              options={enumOptions.modes}
              getOptionLabel={(option) => option || ''}
              value={formData.mode}
              onChange={(event, newValue) => handleSelectChange('mode', newValue)}
              renderInput={(params) => <TextField {...params} required />}
            />
          </Box>
        </Box>

        <Box className="field-container full-width">
          <Typography>Description <span className="required">*</span></Typography>
          <TextField
            name="description"
            multiline
            rows={4}
            fullWidth
            value={formData.description}
            onChange={handleChange}
            required
          />
        </Box>

        <Box className="grid-container">
          <Box className="field-container">
            <Typography>URL</Typography>
            <TextField name="hostURL" type="url" fullWidth value={formData.hostURL} onChange={handleChange} />
          </Box>
          <Box className="field-container">
            <Typography>Online Meeting Link</Typography>
            <TextField name="onlineSessionLink" type="url" fullWidth value={formData.onlineSessionLink} onChange={handleChange} />
          </Box>
        </Box>
        <Box className="field-container">
          <Typography>Event Image</Typography>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => {
              setSelectedImageFile(e.target.files[0]);
            }}
          />
        </Box>

        <Box className="field-container">
          <Typography>Attachments (PDFs)</Typography>
          <input
            type="file"
            multiple
            accept="application/pdf"
            onChange={(e) => {
              setSelectedPdfFiles(Array.from(e.target.files));
            }}
          />
        </Box>
        <Box className="grid-container">
          <Box className="field-container">
            <Typography>Location</Typography>
            <TextField name="location" fullWidth value={formData.location} onChange={handleChange} />
          </Box>
          <Box className="field-container">
            <Typography>Country</Typography>
            <TextField name="country" fullWidth value={formData.country} onChange={handleChange} />
          </Box>
        </Box>

        <Box className="field-container">
          <FormControlLabel
            control={<Checkbox name="yearlyImportant" checked={formData.yearlyImportant} onChange={handleChange} />}
            label="Recurring event"
          />
        </Box>

        <Button type="submit" variant="contained" color="primary" className="submit-button">
          Submit
        </Button>
      </Box>

      <Dialog open={open} onClose={handleClose}>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            {formError && (
              <Typography color="error" sx={{ mt: 1, textAlign: 'center' }}>
                {formError}
              </Typography>
            )}
            <Typography sx={{ mt: 1, textAlign: 'center' }}>Event submitted for approval!</Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AddPost;